import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { FairnessContent } from "../fairnessContent.js";

/**
 * The fairness page, showroom layout: the title and what it means, then the verifier beside the
 * seed lookup from lg (the verifier wider, since its answer is longer). Below lg they stack.
 */
export function FairnessShowroomLayout({ sections }: PageLayoutProps<FairnessContent>) {
  return (
    <Section className="flex flex-col gap-8 pt-8 pb-20 md:gap-10 md:pt-12">
      {sections.intro}
      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        {sections.verify}
        {sections.seed}
      </div>
    </Section>
  );
}
